// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#lcr .BettingSuggestions__bettingSuggestions___1cMmS{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;width:100%;height:100%;max-width:100%;z-index:999999999;padding:50px 0;position:absolute}", ""]);
// Exports
exports.locals = {
	"bettingSuggestions": "BettingSuggestions__bettingSuggestions___1cMmS"
};
module.exports = exports;
